<main [ngClass]="{ 'show-tour-guide': showTourGuide }">
  <router-outlet></router-outlet>
  @if (showTourGuide) {
    <app-tour-guide></app-tour-guide>
  }
  @if (isLoading) {
    <app-loader
      [isLoading]="isLoading"
      class="load-indicator"
      id="MainConsoleDisplay"
      style="height: 100%; width: 100%"
      >
    </app-loader>
  }
  <app-growler></app-growler>
</main>
